import { createBrowserRouter, RouterProvider } from "react-router-dom";
import OIDC from "../oidc";
import CustomerListPage from "./pages/customer/customer-list-page";
import LandingPage from "./pages/landing-page";
import EmployeeListPage from "./pages/employee/employee-list-page";
import LayoutRoot from './root';
import EmployeeDetailsPage from "./pages/employee/employee-details-page";
import CustomerDetailsPage from "./pages/customer/customer-details-page";
import ContractTemplateListPage from "./pages/contract-template/contract-template-list-page";
import ContractTemplateDetailsPage from "./pages/contract-template/contract-template-details-page";
import MapSettings from "./pages/settings/map-settings";
import MapPage from "./pages/map-page";
import ContractSettingsPage from "./pages/settings/contract-settings-page";
import Enums from "./pages/settings/enums";
import PriceSettings from "./pages/settings/price-settings";
import TeamList from "./pages/settings/team-list";
import TeamDetailsPage from "./pages/settings/team-details-page";
import SettlementPage from "./pages/settlement/settlement-page";
import InsuranceList from "./pages/settings/insurance/insurance-list";
import InsuranceDetails from "./pages/settings/insurance/insurance-details";
import WorktimeDetails from "./pages/worktime-details";
import DefaultTasks from "./pages/settings/default-tasks";
import ReportsPage from "./pages/reports-page";
import TasksListPage from "./pages/tasks-list-page";
import InvoiceSettingsPage from "./pages/settings/invoice-settings-page";
import GeneralSettings from "./pages/settings/general-settings";
import LocationList from "./pages/settings/location/location-list";
import LocationDetails from "./pages/settings/location/location-details";
import TasksDetailsPage from "./pages/tasks-details-page";

const Root: React.FC = () => {
  return (
    <OIDC>
      <LayoutRoot />
    </OIDC>
  )
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: 'signin-redirect'
      },
      {
        path: '/',
        element: <LandingPage />,
      },
      {
        path: `customer`,
        element: <CustomerListPage />,
      },
      {
        path: "customer/:id",
        element: <CustomerDetailsPage />,
      },
      {
        path: "customer/:id/:subpage?/:subsubpage?/:subsubsubpage?",
        element: <CustomerDetailsPage />,
      },
      {
        path: "employee",
        element: <EmployeeListPage />,
      },
      {
        path: "employee/:id/:subpage?/:subsubpage?/:subsubsubpage?",
        element: <EmployeeDetailsPage />,
      },
      {
        path: "contract-template",
        element: <ContractTemplateListPage />,
      },
      {
        path: "contract-settings",
        element: <ContractSettingsPage />
      },
      {
        path: "contract-template/:id",
        element: <ContractTemplateDetailsPage />,
      },
      {
        path: "map",
        element: <MapPage />
      },
      {
        path: "settings-map",
        element: <MapSettings />
      },
      {
        path: "enums",
        element: <Enums />
      },
      {
        path: 'task',
        element: <TasksListPage />
      },
      {
        path: 'task',
        element: <TasksListPage />
      },
      {
        path: 'task/:id',
        element: <TasksDetailsPage />
      },
      {
        path: 'default-tasks',
        element: <DefaultTasks />
      },
      {
        path: "price-settings/:subpage?",
        element: <PriceSettings />
      },
      {
        path: "team",
        element: <TeamList />
      },
      {
        path: "team/:id",
        element: <TeamDetailsPage />
      },
      {
        path: "settlement/:subpage?",
        element: <SettlementPage />
      },
      {
        path: "insurance",
        element: <InsuranceList />
      },
      {
        path: "insurance/:id/:subpage?",
        element: <InsuranceDetails />
      },
      {
        path: "location",
        element: <LocationList />
      },
      {
        path: "location/:id",
        element: <LocationDetails />
      },
      {
        path: 'worktime/:id',
        element: <WorktimeDetails />
      },
      {
        path: "reports",
        element: <ReportsPage />
      },
      {
        path: "invoice-settings",
        element: <InvoiceSettingsPage />
      },
      {
        path: "general-settings",
        element: <GeneralSettings />
      }
    ]
  }
]);

function RouterProviderDesktop() {
  return (
    <RouterProvider router={router} />
  )
}

export default RouterProviderDesktop;